import React from 'react';
import Reflux from 'reflux';
import {withRouter} from 'react-router';
import {Button} from 'antd';
import {DmsTab, TableView, AdvanceFormNew} from '../../components';
import {openNotice, config, objectSerial} from 'Utils';
import {settleDetailList} from '../../service/reportForm';
import moment from 'moment';
import {fetchChannelList} from '../../service/order';
import {getGouXiaoUnitList} from "../../service/traceOrder";

class SettleDetailQuery extends Reflux.Component {
    constructor(props) {
        super(props);
        this.state = {
            opts: ['结算明细'],
            key: 0,
            filterBoxVisible: false,
            selectedRowKeys: [],
            rows: [],
            total: 1,
            dateMapTotal: 0,
            searchObj: {
                orderedDateBegin: moment().add(-1, 'y').format('YYYY-MM-DD'),
                orderedDateEnd: moment().add(1, 'days').format('YYYY-MM-DD'),
                orderNumber: '',
                deliveryId: '',
                itemDesc: '',
                salesUnitId: '',
                channel: '',
                itemNum: '',
                s: 10,
                p: 1
            },
            loading: false,
        };
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.exportChange = this.exportChange.bind(this);
    }

    onSelectChange = (selectedRowKeys) => {
        this.setState({selectedRowKeys});
    }


    advanceReset() {
        let self = this;
        self.setState({
            filterBoxVisible: false,
            searchObj: {
                orderNumber: '',
                deliveryId: '',
                itemDesc: '',
                salesUnitId: '',
                channel: '',
                itemNum: '',
                orderedDateEnd: '',
                orderedDateBegin: '',
                s: 10,
                p: 1
            }
        });
    };

    advanceSubmit(form) {
        /* 筛选确认 */
        let self = this;
        if (!this.state.searchObj.orderedDateBegin || this.state.searchObj.orderedDateBegin == '') {
            openNotice('warning', '请选择日期范围后再做查询');
            return;
        }
        if (!this.state.searchObj.orderedDateEnd || this.state.searchObj.orderedDateEnd == '') {
            openNotice('warning', '请选择日期范围后再做查询');
            return;
        }
        this.setState({
            filterBoxVisible: false,
            searchObj: {
                ...this.state.searchObj,
                p: 1
            }
        }, function () {
            self.initData();
        });
    };


    setFilterParam(name, value) {
        if (name === 'date') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    dateFrom: value.from,
                    dateTo: value.end
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}})
        }
    };

    pageChange(page, pageSize) {
        /* 翻页 刷新 */
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, function () {
            self.initData();
        });
    }

    initData() {
        let self = this;
        let searchObj = self.state.searchObj;
        this.setState({
            loading: true
        });
        settleDetailList(searchObj).then(function (result) {
            if (result && result.code == 200) {
                self.setState({
                    rows: result.data || [],
                    total: result.total,
                    dateMapTotal: result.dataMap ? result.dataMap.total : 0,
                    loading: false
                });
            } else {
                openNotice('error', '数据获取失败', '');
                self.setState({
                    loading: false
                });
            }
        });
    }

    /*导出*/
    exportChange() {
        let _searchObj = {...this.state.searchObj};
        delete _searchObj.s;
        delete _searchObj.p;
        let url = `${config.server}/api/v1/dms/orderReport/settleDetailListExportExcel?${objectSerial(_searchObj)}`;
        window.open(url);
    };

    componentWillMount() {
    }

    componentDidMount() {
        let self = this;
        fetchChannelList().then(res => { //渠道
            if (res.status) {
                let arr = [];
                res.data.forEach(x => {
                    arr.push({
                        text: x.name,
                        value: x.code
                    })
                });
                self.setState({channel_type: arr},
                )
            }
        });
        let channelCode = window.sessionStorage.getItem('cur_channelId');
        getGouXiaoUnitList({channelCode: channelCode, s: 999}).then(res => { //购货单位
            if (res.status) {
                let arr = [
                    {
                        text: '全部',
                        value: ''
                    }
                ];
                for (let i = 0; i < res.data.length; i++) {
                    let x = res.data[i];
                    arr.push({
                        text: x.name,
                        value: x.id
                    })
                }
                this.setState({gouxiaoUnitList: arr})
            }
        });
    }

    render() {
        const {opts, key, rows, total, searchObj, loading, channel_type, gouxiaoUnitList} = this.state;
        const filterBoxProps = {
            fileds: [
                {
                    name: 'BOOKED_DATE',//orderedDateBegin, orderedDateEnd
                    label: '发运日期查询',
                    options: [
                        {text: '开始时间'},
                        {text: '结束时间'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.orderedDateBegin || '',
                        end: searchObj.orderedDateEnd || ''
                    },
                },
                {
                    name: 'orderNumber',
                    label: '订单编号',
                    text: '输入订单编号',
                    type: 'default',
                    defaultValue: searchObj.orderNumber
                },
                {
                    name: 'deliveryId',
                    label: '出库单号',
                    text: '输入出库单号',
                    type: 'default',
                    defaultValue: searchObj.deliveryId
                },
                {
                    name: 'itemNum',
                    label: '物料编码',
                    text: '输入物料编码',
                    type: 'default',
                    defaultValue: searchObj.itemNum
                },
                {
                    name: 'itemDesc',
                    label: '物料描述',
                    text: '输入物料描述',
                    type: 'default',
                    defaultValue: searchObj.itemDesc
                },
                {
                    name: 'salesUnitId',
                    label: '购货单位',
                    text: '输入购货单位',
                    type: 'select',
                    defaultValue: searchObj.salesUnitId,
                    showSearch: true,
                    options: gouxiaoUnitList,
                },
                {
                    name: 'salesChannelCode',
                    label: '渠道',
                    text: '选择渠道',
                    options: channel_type,
                    multiple: false,//支持多选
                    type: 'select',
                    defaultValue: searchObj.channel
                }
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: loading,
            rowKey: 'RN',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            scroll: {x: 10000, y: false},
            columns: [
                {
                    title: '发运行ID',
                    dataIndex: '发运行ID',
                }, {
                    title: '订单行ID',
                    dataIndex: '订单行ID',
                }, {
                    title: '折扣核对ID',
                    dataIndex: '折扣核对ID',
                }, {
                    title: '发运日期',
                    dataIndex: '发运日期',
                    render: (text, record, index) => {
                        return <div>{moment(text).format("YYYY-MM-DD")}</div>
                    }
                }, {
                    title: '订购日期',
                    dataIndex: '订购日期',
                    render: (text, record, index) => {
                        return <div>{moment(text).format("YYYY-MM-DD")}</div>
                    }
                }, {
                    title: '登记日期',
                    dataIndex: '登记日期',
                    render: (text, record, index) => {
                        return <div>{moment(text).format("YYYY-MM-DD")}</div>
                    }
                }, {
                    title: '类型',
                    dataIndex: '类型',
                }, {
                    title: '退货类型',
                    dataIndex: '退货类型'
                }, {
                    title: '订单类型',
                    dataIndex: '订单类型',
                }, {
                    title: '提货库存',
                    dataIndex: '提货库存',
                }, {
                    title: '子库存',
                    dataIndex: '子库存',
                }, {
                    title: '订单编码',
                    dataIndex: '订单编码',
                }, {
                    title: '出库单号',
                    dataIndex: '出库单号',
                }, {
                    title: '片区',
                    dataIndex: '片区',
                }, {
                    title: '省市',
                    dataIndex: '省市',
                }, {
                    title: '客户编号',
                    dataIndex: '客户编号',
                }, {
                    title: '客户名称',
                    dataIndex: '客户名称',
                }, {
                    title: '单位ID',
                    dataIndex: '单位ID',
                }, {
                    title: '购货单位',
                    dataIndex: '购货单位',
                }, {
                    title: '销售渠道',
                    dataIndex: '销售渠道',
                }, {
                    title: '付款条件',
                    dataIndex: '付款条件',
                }, {
                    title: '签约类型',
                    dataIndex: '签约类型',
                }, {
                    title: '客户类型',
                    dataIndex: '客户类型',
                }, {
                    title: '物料编码',
                    dataIndex: '物料编码',
                }, {
                    title: '物料描述',
                    dataIndex: '物料描述',
                }, {
                    title: '生产公司',
                    dataIndex: '生产公司',
                }, {
                    title: '生产车间',
                    dataIndex: '生产车间',
                }, {
                    title: '大系列',
                    dataIndex: '大系列',
                }, {
                    title: '中系列',
                    dataIndex: '中系列',
                }, {
                    title: '明细系列',
                    dataIndex: '明细系列',
                }, {
                    title: '产品线',
                    dataIndex: '产品线',
                }, {
                    title: '产品类别',
                    dataIndex: '产品类别',
                }, {
                    title: '产品大类',
                    dataIndex: '产品大类',
                }, {
                    title: '数量',
                    dataIndex: '数量',
                }, {
                    title: '牌价',
                    dataIndex: '牌价',
                }, {
                    title: '牌价金额',
                    dataIndex: '牌价金额',
                }, {
                    title: '基础下浮率',
                    dataIndex: '基础下浮率',
                }, {
                    title: '基础下浮单价',
                    dataIndex: '基础下浮单价',
                }, {
                    title: '基础下浮金额',
                    dataIndex: '基础下浮金额',
                }, {
                    title: '最终下浮率',
                    dataIndex: '最终下浮率',
                }, {
                    title: '销售单价',
                    dataIndex: '销售单价',
                }, {
                    title: '销售金额',
                    dataIndex: '销售金额',
                }, {
                    title: '销售金额(失效)',
                    dataIndex: '销售金额(失效)',
                }, {
                    title: '返利结算基数',
                    dataIndex: '返利结算基数',
                }, {
                    title: '特价追加',
                    dataIndex: '特价追加',
                }, {
                    title: '销售折让',
                    dataIndex: '销售折让',
                }, {
                    title: '提货折让',
                    dataIndex: '提货折让',
                }, {
                    title: '促销追加',
                    dataIndex: '促销追加',
                }, {
                    title: '推广折让',
                    dataIndex: '推广折让',
                }, {
                    title: '特殊订单折让',
                    dataIndex: '特殊订单折让',
                }, {
                    title: '规范经营奖折让',
                    dataIndex: '规范经营奖折让',
                }, {
                    title: '折扣比例',
                    dataIndex: '折扣比例',
                }, {
                    title: '开单折扣金额',
                    dataIndex: '开单折扣金额',
                }, {
                    title: '不含税单价',
                    dataIndex: '不含税单价',
                }, {
                    title: '销售收入',
                    dataIndex: '销售收入',
                }, {
                    title: '销项税',
                    dataIndex: '销项税',
                }, {
                    title: '返利有效开始日期',
                    dataIndex: '返利有效开始日期',
                }, {
                    title: '返利有效结束日期',
                    dataIndex: '返利有效结束日期',
                }, {
                    title: '返利折扣明细类',
                    dataIndex: '返利折扣明细类',
                }, {
                    title: '返利产品类型',
                    dataIndex: '返利产品类型',
                }, {
                    title: '返利产品维度',
                    dataIndex: '返利产品维度',
                }, {
                    title: '返利结算方式',
                    dataIndex: '返利结算方式',
                }, {
                    title: '结算基数',
                    dataIndex: '结算基数',
                }, {
                    title: '返利结算比例',
                    dataIndex: '返利结算比例',
                }, {
                    title: '返利计提单号',
                    dataIndex: '返利计提单号',
                }, {
                    title: '返利特价报告ID',
                    dataIndex: '返利特价报告ID',
                }, {
                    title: '促销大点',
                    dataIndex: '促销大点',
                }, {
                    title: '订单渠道',
                    dataIndex: '订单渠道',
                }, {
                    title: '业务类型',
                    dataIndex: '业务类型',
                }, {
                    title: '签约下浮额',
                    dataIndex: '签约下浮额',
                }, {
                    title: '结算金额',
                    dataIndex: '结算金额',
                }, {
                    title: '折扣结算系数',
                    dataIndex: '折扣结算系数',
                }
            ],
            rows
        };
        return <div>
            <DmsTab options={opts} defaultKey={key}/>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew  {...filterBoxProps} />
                </div>
            </div>
            <div className="dms-table-box">
                <div className="dms-table-head" style={{padding: '8px 8px 8px 0'}}>
                    <span><font size={1} style={{color: 'red'}}>（默认显示一年，如需查历史数据，请重新选择日期)</font></span>
                    <Button style={{position: 'absolute', bottom: 8, right: 0}} icon="export"
                            onClick={this.exportChange}>导出</Button>
                </div>
                <TableView {...tableViewProps} />
            </div>
        </div>
    }
}

export default withRouter(SettleDetailQuery);



// WEBPACK FOOTER //
// ./src/routes/reportForm/settleDetailQuery.js